// @ts-nocheck
import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(
  ['WebformElementWebformMultiple'],
  (item, ctx) => {
    return {
      $formkit: 'repeater',
      addLabel: item.element.addMoreButtonLabel,
      min: item.element.minItems || 1,
      children: ctx.buildChildren(item.element.items),
    }
  },
)
